import { useEffect } from 'react';
import { record } from 'rrweb';
import { sessionId } from '../lib/attribution';

const PRIVATE = /^\/(admin|dashboard|formateur|programme)/;

/** Enregistre le parcours sur notre serveur pour le rejouer dans /admin/analytics, sans compte PostHog. */
export default function ReplayRecorder() {
  useEffect(() => {
    if (PRIVATE.test(window.location.pathname)) return undefined;
    const sid = sessionId();
    let buffer = [];
    let stop = () => {};
    const post = async (events, useBeacon) => {
      if (!events.length) return;
      // `now` : le Worker en déduit l'écart d'horloge et place arrivée / départ à l'heure du serveur.
      let payload = { sid, page: window.location.pathname, now: Date.now(), events };
      const raw = JSON.stringify(payload);
      if (raw.length > 80000 && typeof CompressionStream !== 'undefined') {
        const stream = new Blob([JSON.stringify(events)]).stream().pipeThrough(new CompressionStream('gzip'));
        const bytes = new Uint8Array(await new Response(stream).arrayBuffer());
        let binary = '';
        for (let i = 0; i < bytes.length; i += 32768) binary += String.fromCharCode(...bytes.subarray(i, i + 32768));
        payload = { sid, page: window.location.pathname, now: Date.now(), gzip: btoa(binary) };
      }
      const body = JSON.stringify(payload);
      const snapshot = events.some((event) => event.type === 2);
      const blob = new Blob([body], { type: 'application/json' });
      // Les visites US/CA durent souvent quelques secondes : le beacon part même si la page se ferme.
      if (navigator.sendBeacon && body.length < 60000 && (useBeacon || snapshot)) {
        navigator.sendBeacon('/api/analytics/replay', blob);
        if (useBeacon) return;
      }
      fetch('/api/analytics/replay', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body,
      }).catch(() => {});
    };
    try {
      stop = record({
        emit(event) {
          if (event.type === 2 || event.type === 4) {
            post([event], false);
            return;
          }
          buffer.push(event);
        },
        checkoutEveryNms: 30000,
        maskInputOptions: { password: true },
        slimDOMOptions: 'all',
        inlineStylesheet: false,
        inlineImages: false,
        sampling: { mousemove: 80, scroll: 50, mouseInteraction: true, input: 'last', media: 800 },
      }) || (() => {});
    } catch {
      return undefined;
    }
    const flush = (useBeacon) => {
      if (!buffer.length) return;
      const events = buffer.splice(0, 80);
      post(events, useBeacon);
    };
    const timer = window.setInterval(() => flush(true), 20000);
    const leave = () => flush(true);
    window.addEventListener('pagehide', leave);
    window.addEventListener('visibilitychange', leave);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('pagehide', leave);
      window.removeEventListener('visibilitychange', leave);
      stop();
      flush(true);
    };
  }, []);

  return null;
}
